export default "__VITE_ASSET__5df199a1__"